<app-modal-template
  [size]="PencilModalSizeEnum.MEDIUM"
  [hasCloseButton]="true"
  (closeButtonClicked)="close()"
>
  <div content-description class="checkout-blocked-modal__body">
    <div class="checkout-blocked-modal__title">
      {{
        isVerificationFailed
          ? ('Unable to verify billing' | translate)
          : ('Checkout unavailable' | translate)
      }}
    </div>
    <div class="checkout-blocked-modal__message">{{ message }}</div>
    <div *ngIf="formattedBalance as balance" class="checkout-blocked-modal__balance">
      {{ 'Outstanding balance:' | translate }} {{ balance }}
    </div>
  </div>
  <div content-actions class="checkout-blocked-modal__actions">
    <app-pencil-button
      [theme]="PencilButtonThemeEnum.SECONDARY_OUTLINE"
      [label]="'Contact Support' | translate"
      [icon]="'support_agent'"
      [iconConfig]="{ type: IconTypes.matIcon }"
      [disabled]="isBusy"
      (clickEvent)="contactSupport()"
    ></app-pencil-button>
    <app-pencil-button
      *ngIf="isBlocked"
      [theme]="PencilButtonThemeEnum.PRIMARY"
      [label]="'Review invoices' | translate"
      [icon]="'receipt_long'"
      [iconConfig]="{ type: IconTypes.matIcon }"
      [showSpinner]="isBusy"
      [disabled]="isBusy"
      (clickEvent)="reviewInvoices()"
    ></app-pencil-button>
    <app-pencil-button
      *ngIf="isVerificationFailed"
      [theme]="PencilButtonThemeEnum.PRIMARY"
      [label]="'Try again' | translate"
      [icon]="'refresh'"
      [iconConfig]="{ type: IconTypes.matIcon }"
      [showSpinner]="isBusy"
      [disabled]="isBusy"
      (clickEvent)="tryAgain()"
    ></app-pencil-button>
  </div>
</app-modal-template>
